import React from 'react'
import SvgIcon from 'rambler-ui/icons/SvgIcon'

export default function Logo () {
  return (
    <SvgIcon
      color='currentColor'
      style={{
        width: 15,
        height: 10
      }}
      viewBox='0 0 15 10'>
      <path d='M3 5V4L0 5.5 3 7V6h12V5H3z' />
    </SvgIcon>
  )
}
